import { createContext, useContext, ReactNode } from "react";
import { useWorkTimer, TimerState, TimerMode } from "@/hooks/useWorkTimer";
import { TimerFloatingWidget } from "./TimerFloatingWidget";

interface WorkTimerContextValue {
  timerState: TimerState;
  startTimer: (opts: {
    mode: TimerMode;
    targetMinutes?: number;
    cafeId?: string;
    cafeName?: string;
    checkInId?: string;
  }) => Promise<void>;
  pauseTimer: () => void;
  resumeTimer: () => void;
  stopTimer: (focusRating?: number) => Promise<void>;
  skipPhase: () => void;
  setMode: (m: TimerMode) => void;
  setCountdownDuration: (minutes: number) => void;
  getPhaseLabel: () => string;
}

const WorkTimerContext = createContext<WorkTimerContextValue | null>(null);

export function useWorkTimerContext() {
  const ctx = useContext(WorkTimerContext);
  if (!ctx) throw new Error("useWorkTimerContext must be used within WorkTimerProvider");
  return ctx;
}

export function WorkTimerProvider({ children }: { children: ReactNode }) {
  const timer = useWorkTimer();

  return (
    <WorkTimerContext.Provider value={timer}>
      {children}
      <TimerFloatingWidget />
    </WorkTimerContext.Provider>
  );
}
